import React, { FC, useEffect, useState } from "react";
import { AzureAD } from "react-aad-msal";
import { AuthenticationState } from "react-aad-msal";
import { IAzureADFunctionProps } from "react-aad-msal";
import { mergeStyleSets, Stack, Persona, PersonaSize } from "@fluentui/react";
import { NavLink } from "react-router-dom";
import { AuthProvider } from "./../../AuthProvider";
import { store } from "../../index";
import { connect } from "react-redux";
import { State } from "../../store";
import { graphApi } from "../../api/graphApi";
import { accountApi } from "../../api/accountApi";
import { Image } from "@fluentui/react";
import OfflineDataPane from "../sof/OfflineDataPane";
import * as GeneralStore from "../../store/GeneralStore";

type Props = GeneralStore.GeneralState & typeof GeneralStore.actionCreators;

const classes = mergeStyleSets({
  div: {
    float: "right",
    margin: "10px"
  },
  profileDiv: {
    float: "right",
    display: "flex",
    alignItems: "center",
    paddingLeft: "20px",
    // marginTop: "-5px",
    fontSize: "15px"
  },
  profileSpan: {
    display: "inline-block",
    paddingRight: "10px",
    width: "40px"
  },
  h1: {
    lineHeight: "35px"
  }
});

const Header: FC<Props> = (props: Props) => {
  const [profilePic, setProfilePic] = useState<string | null>(null);

  const getProfilePic = async () => {
    try {
      const image = await graphApi.getPhoto();
      const profilePic = Buffer.from(image.data, "binary").toString("base64");
      await accountApi.updateUserProfileAsync(profilePic);

      setProfilePic(profilePic);
    } catch {
      console.log("error getting image");
    }
  };

  useEffect(() => {
    getProfilePic();

    setUserRoles();
  }, []);

  const setUserRoles = async () => {
    const res = await graphApi.getUserGroups();
    const memberOf = res.data.value;
    let result = memberOf.map((a: any) => a.id);
    const userRoles = await accountApi.getUserRolesAsync(result);

    //Marine permissions
    if (userRoles.indexOf("MARINE_EDIT_ACTIVITY") > -1) {
      props.setMarineEditActivityAllowed(true);
    }

    if (userRoles.indexOf("MARINE_EDIT_TIMESTAMP") > -1) {
      props.setMarineEditTimestampAllowed(true);
    }

    if (userRoles.indexOf("MARINE_ADD_COMMENT") > -1) {
      props.setMarineAddCommentAllowed(true);
    }

    if (userRoles.indexOf("MARINE_DELETE_COMMENT") > -1) {
      props.setMarineDeleteCommentAllowed(true);
    }

    if (userRoles.indexOf("MARINE_UNDO_EXTENDED") > -1) {
      props.setMarineUndoExtendedAllowed(true);
    }

    if (userRoles.indexOf("MARINE_EDIT_ETA") > -1) {
      props.setMarineEditETAAllowed(true);
    }

    if (userRoles.indexOf("MARINE_REJECT_LINEHANDLING") > -1) {
      props.setMarineRejectLineHandlingAllowed(true);
    }

    if (userRoles.indexOf("MARINE_UPLOAD_FILE") > -1) {
      props.setMarineUploadFileAllowed(true);
    }

    if (userRoles.indexOf("MARINE_PROCESS_DWP") > -1) {
      props.setMarineProcessDWPAllowed(true);
    }

    if (userRoles.indexOf("MARINE_DELIVERY_TRUCK_ONLY") > -1) {
      props.setMarineProcessDWPTruckOnly(true);
    }

    if (userRoles.indexOf("MARINE_PROCESS_ADDITIONAL_SERVICES") > -1) {
      props.setMarineProcessAdditionalServices(true);
    }

    if (userRoles.indexOf("MARINE_APPROVE_LINEHANDLING") > -1) {
      props.setApproveLineHandlingAllowed(true);
    }

    if (userRoles.indexOf("MARINE_LOC_PHL") > -1) {
      props.setMarineSalesOrg("PHL");
    } else if (userRoles.indexOf("MARINE_LOC_USA") > -1) {
      props.setMarineSalesOrg("USA");
    } else {
      props.setMarineSalesOrg("ALL");
    }

    //Truck permissions
    if (userRoles.indexOf("TRUCK_EDIT_ACTIVITY") > -1) {
      props.setTruckEditActivityAllowed(true);
    }

    if (userRoles.indexOf("TRUCK_EDIT_TIMESTAMP") > -1) {
      props.setTruckEditTimestampAllowed(true);
    }

    if (userRoles.indexOf("TRUCK_ADD_COMMENT") > -1) {
      props.setTruckAddCommentAllowed(true);
    }

    if (userRoles.indexOf("TRUCK_DELETE_COMMENT") > -1) {
      props.setTruckDeleteCommentAllowed(true);
    }

    if (userRoles.indexOf("TRUCK_UNDO_EXTENDED") > -1) {
      props.setTruckUndoExtendedAllowed(true);
    }

    if (userRoles.indexOf("TRUCK_UPLOAD_FILE") > -1) {
      props.setTruckUploadFileAllowed(true);
    }

    if (userRoles.indexOf("TRUCK_PROCESS_DWP") > -1) {
      props.setTruckProcessDWPAllowed(true);
    }

    if (userRoles.indexOf("TRUCK_PROCESS_ADDITIONAL_SERVICES") > -1) {
      props.setTruckProcessAdditionalServices(true);
    }

    if (userRoles.indexOf("TRUCK_APPROVE_REJECTION") > -1) {
      props.setTruckApproveRejectionAllowed(true);
    }

    if (userRoles.indexOf("TRUCK_UPDATE_ASSIGNMENT") > -1) {
      props.setTruckUpdateAssignmentAllowed(true);
    }

    if (userRoles.indexOf("TRUCK_LOC_PHL") > -1) {
      props.setTruckSalesOrg("PHL");
    } else if (userRoles.indexOf("TRUCK_LOC_USA") > -1) {
      props.setTruckSalesOrg("USA");
    } else {
      props.setTruckSalesOrg("ALL");
    }
  };

  const [isHovered, setIsHovered] = useState(false);

  const buttonStyle = {
    fontFamily: 'inherit',
    color: isHovered ? '#262626' : '#0f7f79',
    textDecoration: isHovered ? 'underline' : 'none',
    backgroundColor: 'transparent',
    borderRadius: '0.25rem',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '0',
    transition: 'color 0.2s, text-decoration 0.2s',
  };

  const handleClick = () => {
    window.location.href = "https://sofproduct-dev-webapp.azurewebsites.net/pulse";
  };

  return (
    <nav className="nav-header">
       <div style={{ display: 'flex', flex: '1 1 0%', alignItems: 'center', paddingLeft: '1rem' }}>
      <div
        onClick={handleClick}
        style={buttonStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        ← Back
      </div>
    </div>
      <AzureAD provider={AuthProvider} reduxStore={store.store}>
        {(a: IAzureADFunctionProps) => {
          if (a.authenticationState === AuthenticationState.Authenticated) {
            return (
              <div className={classes.div}>
                <Stack horizontal style={{ alignItems: "center" }}>
                  <OfflineDataPane />
                  {a.accountInfo && (
                    <NavLink to="/signout" exact>
                      <div className={classes.profileDiv}>
                        <span className={classes.profileSpan}>
                          {profilePic && (
                            <Image
                              style={{
                                borderRadius: "50%",
                                height: "auto"
                              }}
                              src={`data:image/jpeg;base64, ${profilePic}`}
                              width="30"
                              height="30"
                            />
                          )}
                          {!profilePic && (
                            <Persona
                              size={PersonaSize.size32}
                              initialsColor={"var(--primary-500)"}
                              color={"var(--primary-500)"}
                              imageInitials={a
                                .accountInfo!.account.name.split(" (")[0]
                                .split(" ")
                                .map((n, i, a) =>
                                  i === 0 || i + 1 === a.length ? n[0] : null
                                )
                                .join("")}
                            />
                          )}
                        </span>
                      </div>
                    </NavLink>
                  )}
                </Stack>
              </div>
            );
          } else {
            return (
              <div className={classes.div}>
                <button onClick={a.login}>Login</button>
              </div>
            );
          }
        }}
      </AzureAD>
    </nav>
  );
};

export default connect(
  (state: State) => state.general,
  GeneralStore.actionCreators
)(Header as any);
